<template>
    <div id="step4">
        <a-result v-if="initCloseValue.invTempDetailList == null || initCloseValue.invTempDetailList.length == 0" status="warning" title="Please select item(s) first."></a-result>
        <a-row v-else>
            <a-row style="font-size: 13px;font-weight: 800;" class="sbxs mt4" type="flex" justify="space-between">
                <a-col>
                    <a-icon type="caret-down" />Shipment Instruction
                </a-col>
            </a-row>
            <a-row class="step5_Order">
                <a-form :form="form">
                    <a-row>
                        <a-col :span="12">
                            <a-form-item label="Delivery Date" v-bind="formItemLayout">
                                <a-date-picker
                                        :placeholder="$t('publicLang.PleaseSelect')"
                                        format="YYYY-MM-DD"
                                        style="width: 100%;"
                                        size="small"
                                        @change="deliveryDateChange"
                                        :disabled-date="disabledDate"
                                        v-decorator="['etd',
                                     {
                                         initialValue: initCloseValue.etd ? moment(initCloseValue.etd, 'YYYY-MM-DD') : null,
                                         rules: [{ required: true, message: $t('publicLang.Required') }]
                                     }]"/>

                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Order Date" v-bind="formItemLayout">
                                <a-date-picker
                                        :placeholder="$t('publicLang.PleaseSelect')"
                                        format="YYYY-MM-DD HH:mm:ss"
                                        style="width: 100%;"
                                        size="small"
                                        disabled
                                        show-time
                                        v-decorator="['rderDate',{ initialValue: moment(new Date(), 'YYYY-MM-DD h:mm:ss') }]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="8" offset="1">
                            <a-form-item label="Order No" v-bind="formItemLayout">
                                <a-input
                                        :placeholder="$t('publicLang.PleaseEnter')"
                                        autocomplete="off"
                                        size="small"
                                        v-decorator="['orderNo',
                                { initialValue: initCloseValue.orderNo,rules: [{ required: true, message: $t('publicLang.Required') }]}]"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="3">
                            <a-form-item label="Hold" v-bind="formItemLayout">
                                <a-checkbox :checked="onHold" @change="checkOnHold"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Order Type" v-bind="formItemLayout">
                                <a-select
                                        allowClear
                                        disabled
                                        :placeholder="$t('publicLang.PleaseSelect')"
                                        size="small"
                                        v-decorator="['orderType',
                                { initialValue: initCloseValue.orderType == null ? 'Normal' : initCloseValue.orderType,rules: [{ required: true, message: $t('publicLang.Required') }]}]">
                                    <a-select-option v-for="item in stepSelectData.orderType" :value="item.code">{{item.codeDesc}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
<!--                        <a-col :span="12" v-if="false">-->
<!--                            <a-form-item label="Courier" v-bind="formItemLayout">-->
<!--                                <a-select-->
<!--                                        :placeholder="$t('publicLang.PleaseSelect')"-->
<!--                                        size="small"-->
<!--                                        v-decorator="['courier',{initialValue: initCloseValue.courier}]">-->
<!--                                    <a-select-option v-for="item in stepSelectData.courrierData" :value="item.partnerName">{{item.partnerName}}</a-select-option>-->
<!--                                </a-select>-->
<!--                            </a-form-item>-->
<!--                        </a-col>-->
                        <a-col :span="12">
                            <a-form-item label="VAS Instruction" v-bind="formItemLayout">
                                <div style="position: relative;">
                                    <a-textarea
                                            :auto-size="{ minRows: 3, maxRows: 5 }"
                                            autocomplete="off"
                                            :placeholder="$t('publicLang.PleaseEnter')"
                                            size="small"
                                            v-decorator="['vasInstruction',{
                                        initialValue: vasInsRefsSelect
                                    }]"/>
                                    <a-icon type="search" class="sbxs" style="position: absolute;right: 6px;top: 6px;" @click="vasInsSearch"/>
                                </div>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Remark" v-bind="formItemLayout">
                                <a-textarea
                                        autocomplete="off"
                                        :auto-size="{ minRows: 3, maxRows: 5 }"
                                        :placeholder="$t('publicLang.PleaseEnter')"
                                        size="small"
                                        v-decorator="['remark',{initialValue: initCloseValue.remark}]"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Delivery Mode" v-bind="formItemLayout">
                                <a-select
                                        :placeholder="$t('publicLang.PleaseSelect')"
                                        size="small"
                                        v-decorator="['deliveryMode',{initialValue: initCloseValue.deliveryMode}]">
                                    <a-select-option v-for="item in stepSelectData.deliveeryMode" :value="item.code">{{item.codeDesc}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </a-row>
        </a-row>
        <div
                :style="{
              position: 'absolute',
              right: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              zIndex: 1,}">
            <a-button @click='goTypeClick("Back")' class="fl" type="primary" size="small"><img src="../../../../assets/img/Liqutor-left.png" width="13" height="12" class="mr4">Previous</a-button>
            <a-button :disabled="initCloseValue.invTempDetailList == null || initCloseValue.invTempDetailList.length == 0" @click='goTypeClick("Next")' class="fr" type="primary" size="small"><img src="../../../../assets/img/Liqutor-arrow-right.png" width="13" height="12" class="mr4">Next</a-button>
            <div style="text-align: center">
                <a-button :disabled="initCloseValue.invTempDetailList == null || initCloseValue.invTempDetailList.length == 0" @click="saveStep4" type="primary" size="small"><img src="../../../../assets/img/Liqutor-save.png" width="13" height="12" class="mr4">Save and Exit</a-button>
                <a-popconfirm
                        title="Are you sure reset?"
                        ok-text="Yes"
                        cancel-text="No"
                        @confirm="resetStep4"
                >
                    <a-button :disabled="initCloseValue.invTempDetailList == null || initCloseValue.invTempDetailList.length == 0" style='margin-left: 40px;' type="danger" size="small"><img src="../../../../assets/img/Liqutor-refresh.png" width="13" height="12" class="mr4">Reset</a-button>
                </a-popconfirm>
            </div>
        </div>


        <a-modal
            title="VAS Instruction"
            :visible="vasInsVis"
            width="80%"
            @cancel="() => (vasInsVis = !vasInsVis)">
            <template slot="footer">
                <a-button size="small" type="primary" @click="saveVasInsTable">Save</a-button>
            </template>
            <a-row style="height: 300px;">
                <vxe-table
                    stripe
                    highlight-hover-row
                    border
                    resizable
                    show-overflow
                    :data.sync="vasInsVistable"
                    size="mini"
                    height="auto"
                    ref="vasInsRefs"
                >
                    <template v-slot:empty>
                        <span style="font-size: 12px; color: red;"> {{ $t('pubGicSet.NoRecordfound') }} </span>
                    </template>
                    <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                    <vxe-table-column field="code" title="VAS Instruction" show-header-overflow="ellipsis" show-overflow="ellipsis" ></vxe-table-column>
                </vxe-table>
            </a-row>
        </a-modal>


    </div>
</template>
<script>
    import moment from "moment";
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    export default{
        props:{
            initCloseValue:{
                type: Object,
                default: function() {
                    return {};
                }
            },
            stepSelectData: {
                type: Object,
                default: function() {
                    return {};
                }
            },
        },
        data(){
            return{
                form: this.$form.createForm(this),
                initIsUrgent: '',
                vasInsVis: false,
                vasInsVistable: [],
                vasInsRefsSelect: '', // vasinsRefSelect 选中的数据
                step4SelectData: {},
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 6 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                onHold:false,//默认不选中
            }
        },
        watch:{

         initCloseValue(){
                this.clearFromInitValue()
                if(this.stepSelectData.deliveeryMode.length == 1){
                    if(this.initCloseValue.deliveryMode == undefined || this.initCloseValue.deliveryMode == null){
                        this.initCloseValue.deliveryMode =  this.stepSelectData.deliveeryMode[0].code
                    }
                }
                this.vasInsRefsSelect = this.initCloseValue.vasInstruction
                this.onHold = this.initCloseValue.onHold == 'Y' ? true : false
         }
        },
        created(){
            if(this.stepSelectData.deliveeryMode.length == 1){
                if(this.initCloseValue.deliveryMode == undefined || this.initCloseValue.deliveryMode == null){
                    this.initCloseValue.deliveryMode =  this.stepSelectData.deliveeryMode[0].code
                }
            }
            this.vasInsRefsSelect = this.initCloseValue.vasInstruction
        },
        methods:{
            moment,
            deliveryDateChange(val){
                this.form.setFieldsValue({['orderType']: 'Normal' })
                this.initIsUrgent = ''
                let td=new Date();
                td=new Date(td.getFullYear(),td.getMonth(),td.getDate());
                let od=new Date(val);
                od=new Date(od.getFullYear(),od.getMonth(),od.getDate());
                let xc=(od-td)/1000/60/60/24;
                let that = this
                if(xc<2 && this.form.getFieldValue('orderType') == 'Normal'){
                    ajax.post(api.INVWINEDROPDOWN,{code: 'SO_URGENT_TIME'}).then(res=>{
                        let d = new Date();
                        let my_hours=d.getHours();
                        let my_minutes=d.getMinutes();
                        let my_seconds=d.getSeconds();
                        let targetTime = my_hours+ ':'+ my_minutes + ':'+ my_seconds
                        let data = res.data
                        if(data.length > 0){
                            let str = res.data[0].code
                            if(this.timeFliter(targetTime) > this.timeFliter(str) && this.timeFliter(targetTime) != this.timeFliter(str)){
                                that.$confirm({
                                    title: 'Please confirm place urgent order',
                                    okText: 'Yes',
                                    okType: 'danger',
                                    cancelText: 'No',
                                    onOk() {
                                        that.form.setFieldsValue({['orderType']: 'Urgent' })
                                        that.initIsUrgent = 'Y'
                                    },
                                    onCancel() {
                                        that.initIsUrgent = ''
                                        that.form.setFieldsValue({['etd']: null })
                                    },
                                });
                            }
                        }
                    })
                }
            },
            timeFliter(time){
                let s = '';
                let hour = time.split(':')[0];
                let min = time.split(':')[1];
                let sec = time.split(':')[2];
                if(sec != undefined){
                  s = Number(hour*3600) + Number(min*60) + Number(sec);
                }else{
                    s = Number(hour*3600) + Number(min*60)
                }
                return s
            },
            disabledDate(current) {
                return current && current < moment().endOf('day');
            },
//            去搜索vasIn
            vasInsSearch(){
                this.vasInsVis = true
                ajax.post(api.INVWINEVASINSTRUCTION).then(res=>{
                    this.vasInsVistable = res.data
                })
            },
//            vasIns 保存
            saveVasInsTable(){
                let vasInsRefsSelect = this.$refs.vasInsRefs.getCheckboxRecords();
                if(vasInsRefsSelect.length > 0){
                    let str = ''
                    for(let i in vasInsRefsSelect){
                        str = str + vasInsRefsSelect[i].code + '\n'
                    }
                    this.vasInsRefsSelect = str
                    this.form.setFieldsValue({vasInstruction: this.vasInsRefsSelect})
                }
                this.vasInsVis = false
            },
//            save
            saveStep4(){
                this.form.validateFields((err, values)=>{
                    if(!err){
                        let params = {
                               "courier": values.courier,
                               "currentStep": "4",
                               "delieveryDate": values.rderDate ? (values.rderDate).format("YYYY-MM-DD HH:mm:ss") : null ,
                               "delieveryMode": values.deliveryMode,
                               "etd": values.etd ? (values.etd).format("YYYY-MM-DD") : null,
                               "orderNo": values.orderNo,
                               "orderType": values.orderType,
                               "remark": values.remark,
                               "vasInstruction": values.vasInstruction,
                               "onHold":this.onHold == true ? 'Y' : 'N'
                           }
                        params.isUrgent = this.initIsUrgent
                        values.rderDate = values.rderDate ?  (values.rderDate).format("YYYY-MM-DD HH:mm:ss") : null
                        values.etd = values.etd ?  (values.etd).format("YYYY-MM-DD") : null
                        ajax.post(api.INVWINEADDTEMPORDER, params).then(res=>{
                            if(res.code == 200){
                                this.$message.success(res.msg);
                                this.$emit('emitValue',{type: 'step4', data: values})
                                this.$emit('goClose','close')
                            }else{
                                this.$message.warning(res.msg);
                            }
                        })
                    }
                })
            },
            goTypeClick(type){
              if(this.initCloseValue == null || this.initCloseValue == undefined || this.initCloseValue.invTempDetailList == null || this.initCloseValue.invTempDetailList.length == 0){
                   if(type != 'Back'){
                        this.$emit('goType',type)
                   }
                   return
                }
                if(type != 'Back'){
                    this.form.validateFields((err, values)=>{
                        if(!err){
                            let params = {
                                "courier": values.courier,
                                "currentStep": "4",
                                "delieveryDate": values.rderDate ? (values.rderDate).format("YYYY-MM-DD HH:mm:ss") : null ,
                                "delieveryMode": values.deliveryMode,
                                "etd": values.etd ? (values.etd).format("YYYY-MM-DD") : null,
                                "orderNo": values.orderNo,
                                "orderType": values.orderType,
                                "remark": values.remark,
                                "vasInstruction": values.vasInstruction,
                                "onHold":this.onHold == true ? 'Y' : 'N'
                            }
                            params.isUrgent = this.initIsUrgent
                            values.rderDate = values.rderDate ?  (values.rderDate).format("YYYY-MM-DD HH:mm:ss") : null
                            values.etd = values.etd ?  (values.etd).format("YYYY-MM-DD") : null
                            ajax.post(api.INVWINEADDTEMPORDER, params).then(res=>{
                                if(res.code == 200){
                                    if(type == 'Next' || type == 'step5'){
                                       this.$message.success(res.msg);
                                    }
                                    this.$emit('goType',type)
                                }else{
                                    this.$message.warning(res.msg);
                                }
                            })
                        }
                    })
                }else{
                    this.$emit('goType',type)
                }
            },
//            清除
            resetStep4(){
                let params = {
                    currentStep: '4',
                }
                ajax.post(api.INVWINEADDTEMPORDER,params).then(res=>{
                    if(res.code == 200){
                        this.form.resetFields();
                    }else{
                        this.$message.warning(res.msg);
                    }
                })
            },
            clearFromInitValue(){
                this.form.resetFields()
            },
            checkOnHold(e){
                this.onHold = e.target.checked;
            },
        }
    }
</script>
<style lang="less">
    #step4{
        padding:6px 15px 0 15px;
        .step5_Order{
            border: 1px solid #929292;
            background: #fafafa;
            padding: 8px;
        }
    }
</style>